import React, { ReactElement, useContext, useEffect } from 'react'
import RightSideButton from 'components/FileUploader/components/RightSide/components/RightSideButton'
import { FrontIdModal } from 'components/FrontIdModal/FrontIdModal'
import { IFileUploaderModal, IRightSide } from '../../interface'
import { showModalFileTitles } from 'utils/constants'
import { UIContext } from 'shared/context/UIContext'
import './RightSide.scss'

const RightSide = ({
  defaultFileName,
  defaultFileURL,
  disabled,
  getInputProps,
  input,
  isFailUpload,
  isFileAccepted,
  isFileDialogActive,
  isFileRejected,
  loading,
  noDrag,
  onClickDelete,
  open,
  title
}: IRightSide): ReactElement => {
  const { createModal, removeModal } = useContext(UIContext)
  const showModal = showModalFileTitles.includes(title)
  const modals: IFileUploaderModal = {
    officialIDFront: () =>
      createModal(<FrontIdModal hiddenModal={removeModal} open={open} />, {
        className: 'front-id-modal',
        width: '730px'
      })
  }
  const onClick = (): void => {
    if (showModal) {
      modals[title]()
      return
    }
    open()
  }

  useEffect(() => {
    if (showModal && isFileDialogActive) {
      removeModal()
    }
  }, [isFileDialogActive])

  return (
    <div className='right-side'>
      <div className='file-area'>
        <RightSideButton
          defaultFileName={defaultFileName}
          defaultFileURL={defaultFileURL}
          onClick={onClick}
          isFileAccepted={isFileAccepted}
          isFileRejected={isFileRejected}
          isFailUpload={isFailUpload}
          onClickDelete={onClickDelete}
          disabled={disabled}
          noDrag={noDrag}
          loading={loading}
        />
        {input && <input {...getInputProps()} name={input.name} />}
      </div>
    </div>
  )
}

export default RightSide
